import { render, staticRenderFns } from "./welfareNotice.vue?vue&type=template&id=5688d8ff&scoped=true&"
import script from "./welfareNotice.vue?vue&type=script&lang=js&"
export * from "./welfareNotice.vue?vue&type=script&lang=js&"
import style0 from "./welfareNotice.vue?vue&type=style&index=0&id=5688d8ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5688d8ff",
  null
  
)

component.options.__file = "welfareNotice.vue"
export default component.exports